import customColors from './custom-colors';
import customColorsCleanUp from './custom-colors-clean-up';

export default {
  customColors,
  customColorsCleanUp,
};
